import { Component, OnInit, Input, EventEmitter, OnChanges, SimpleChanges, ViewChild, Output } from '@angular/core';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, debounceTime, switchMap } from 'rxjs/operators';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { CityService } from '../../services/city.service';
import { City } from '../../models/models';

@Component({
    selector: 'city-dropdown',
    templateUrl: './city-dropdown.component.html',
    standalone: false
})
export class CityDropdown implements OnInit, OnChanges {
    @Input() parentForm: UntypedFormGroup = new UntypedFormGroup({});
    @Input() ctrlName: string = "cityCtrl";
    @Input() cityId: number = 0;
    @Input() placeholder: string = "Select";
    @Input() isChooseFirstCity: boolean = false;
    @Input() isCityStateZip: boolean = false;
    @Input() isDisabled: boolean = false;
    @Input() isRequired: boolean = false;
    @Input() defaultCity: string = "";

    @Output() citySelected = new EventEmitter<any>();
    @Output() cityBlurred = new EventEmitter<any>();

    @ViewChild('autoTrigger', { static: false, read: MatAutocompleteTrigger }) autoTrigger!: MatAutocompleteTrigger;
    @ViewChild('city', { static: false }) city!: MatAutocomplete;

    public cities: City[] = [];
    public citiesStartsWith: Array<string> = [];
    public filteredCities: Observable<City[]> = new Observable<City[]>();
    public selectedCityId: number = 0;
    public ariaLabel: string = "";
    public isError: boolean = false;
    public errorDetail: string = "";
    public isKendo: boolean = false;

    constructor(private applicationControlService: ApplicationControlService, private cityService: CityService) {
    }

    ngOnInit() {
        this.applicationControlService.getApplicationControlsByAppName('UITypeaheadSource', false).subscribe(result => {
            if (result.length > 0) {
                this.isKendo = result[0].appSettingValue == "kendo";
                this.isKendo = false;
            }
        });
        this.initValues();
    }

    ngOnChanges(changes: SimpleChanges) {
        var ok = changes;

        if (this.defaultCity != "") {
            this.placeholder = this.defaultCity;
            this.parentForm!.controls[this.ctrlName].setValue(this.defaultCity);
        }

        if (changes.cityId == null || changes.cityId.currentValue == null) return;

        this.selectedCityId = parseInt(changes.cityId.currentValue);
    }

    private initValues() {
        if (!this.placeholder) {
            this.placeholder = "";
        }
        this.ariaLabel = this.placeholder;
        //this.getCities();
        if (this.defaultCity != "") {
            this.placeholder = this.defaultCity;
            this.parentForm!.controls[this.ctrlName].setValue(this.defaultCity);
            this.errorDetail = "";
        }
        else {
            this.errorDetail = "Please " + this.placeholder.toLowerCase();
        }
        this.cities.length = 0;
        this.citiesStartsWith.length = 0;
        this.selectedCityId = 0;

        this.setFilter();
    }

    private setFilter() {
        this.filteredCities = this.parentForm!.controls[this.ctrlName].valueChanges.pipe(
            startWith(''),
            debounceTime(300),
            switchMap(city => city ? this.filterCities(city) : new Array())
            //map(city => city ? this.filterCities(city) : new Array())
        );
    }

    private filterCities(cityName: string) {
        if (typeof cityName !== 'string') return new Array();
        const filterValue = cityName.toLowerCase();
        if (filterValue.length < 2) return new Array();
        //if (this.citiesStartsWith.indexOf(filterValue) > -1) {
        //    // Get cached data
        //    return 
        //}
        return this.cityService.getCitiesStartingWith(cityName);
    }

    public getCityLookup(value: string) {
        //console.log("filterCustomers", value);
        this.cityService.getCitiesStartingWith(value).subscribe(result => {
            var lst: City[] = result;
            lst = lst.sort((left, right): number => {
                if (left.cityST < right.cityST) return -1;
                if (left.cityST > right.cityST) return 1;
                return 0;
            });
            this.cities = lst;
        });
    }

    public chooseActiveCity(event: any) {
        console.log("city-dropdown.chooseActiveCity", event);
        if (this.autoTrigger.activeOption) {
            this.parentForm!.controls[this.ctrlName].setValue(this.autoTrigger.activeOption.value);
            this.optionChanged(event);
            return;
        }
        if (this.isChooseFirstCity != true || this.city.options.length < 1) return;

        this.parentForm!.controls[this.ctrlName].setValue(this.city.options.first.value);
    }

    public optionChanged(evt: any) {
        console.log("city-dropdown.optionChanged", evt);
        if (this.isKendo) {
            var idx = this.cities.findIndex(t => t.cityID == evt);
            //console.log("optionChanged", idx);
            if (idx >= 0) {
                console.log("optionChanged", this.cities[idx]);
                this.citySelected.emit(this.cities[idx].cityID);
            }
        }
        else {
            if (evt.option) {
                this.selectedCityId = evt.option.value.cityId;
                this.citySelected.emit(evt);
            }
            else if (evt.cityId) {
                this.selectedCityId = evt.cityId;
                this.citySelected.emit(evt);
            }
            else {
                this.citySelected.emit(0);
            }
        }
        this.filteredCities = new Observable<City[]>();

        this.setFilter();
    }

    public optionBlurred() {
        console.log("city-dropdown.optionBlurred", this.selectedCityId, this.citiesStartsWith, this.cities);
        //if (this.citiesStartsWith.length == 0) {
        //    this.citySelected.emit(0);
        //}
        this.cityBlurred.emit();
    }

    public displayCity(city?: City): string | undefined {
        return city ? (this.isCityStateZip ? city.cityStateZip : city.cityST) : undefined;
        //return city ? city.cityStateZip : undefined;
    }

    public isValid() {
        if (this.isRequired) {
            //return this.parentForm!.controls[this.ctrlName].hasError('required');
            return this.selectedCityId > 0;
        }
        else {
            return true;
        }
    }
}
